/* global cURL */
export class CustomEditor {
  constructor() {
    this.#bindEvents();
  }

  #bindEvents() {
    document.querySelectorAll('[data-custom-editor]').forEach(el => {
      el.addEventListener('click', this.#openEditor);
    });
  }

  #openEditor = e => {
    e.preventDefault();
    const el = e.currentTarget;
    this.#handleOpen(el);
  };

  #handleOpen(triggerElement) {
    const oid = triggerElement.dataset.objectId;
    let params = `?type=${triggerElement.dataset.type}`;
    if (oid) params += `&oid=${oid}`;

    window.open(
      `${cURL}custom-editor.jsp${params}`,
      triggerElement.dataset.windowTitle,
      'left=100,top=100,width=1010,height=700,status=no,resizable=yes,scrollbars=yes'
    );
  }
}
